import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const School = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  const [schoolName, setSchoolName] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [schoolAddress, setSchoolAddress] = useState("");
  const [municipalityId, setMunicipalityId] = useState("");

  const [municipalities, setMunicipalities] = useState([]);
  const [filters, setFilters] = useState({ searchKey: "" });
  const [schools, setSchools] = useState([]);
  const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
      const [totalRecords, setTotalRecords] = useState(0);
      const [totalPages, setTotalPages] = useState(1);
  const [classList, setClassList] = useState([]);
  const [sections, setSections] = useState([]);

  const [showImportModal, setShowImportModal] = useState(false);
const [csvFile, setCsvFile] = useState(null);
const [previewData, setPreviewData] = useState([]);
const [csvErrors, setCsvErrors] = useState([]);
const [establishmentYear, setEstablishmentYear] = useState("");
const [lowClass, setLowClass] = useState("");
const [highClass, setHighClass] = useState("");
const [management, setManagement] = useState("");
const [category, setCategory] = useState("");
const [type, setType] = useState("");
const [managementList, setManagementList] = useState([]);
const [categoryList, setCategoryList] = useState([]);
const [typeList, setTypeList] = useState([]);
const [subDivisions, setSubDivisions] = useState([]);
const [circleList, setcircleList] = useState([]);
const [subDivisionId, setSubDivisionId] = useState("");
const [circleId, setCircleId] = useState("");
// const [lowClass, setLowClass] = useState("");
// const [highClass, setHighClass] = useState("");

const [classStrengths, setClassStrengths] = useState([
  {
    id: Date.now(),
    class_id: "",
    section_id: "",
    boys: "",
    girls: "",
    others: "",
  },
]);


const getAuthHeader = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });


  const navigate = useNavigate();

const addClassRow = () => {
  setClassStrengths([
    ...classStrengths,
    {
      id: Date.now(), // unique key
      class_id: "",
      section_id: "",
      boys: "",
      girls: "",
      others: "",
    },
  ]);
};


const removeClassRow = (index) => {
  const updated = [...classStrengths];
  updated.splice(index, 1);
  setClassStrengths(updated);
};

const handleClassChange = (index, field, value) => {
  const updated = [...classStrengths];
  updated[index][field] = value;
  setClassStrengths(updated);
};

  /* FETCH MUNICIPALITIES */
  const fetchMunicipalities = async () => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(`${BASE_URL}/municipalityList`,{} ,{
        headers: { Authorization: `Bearer ${token}` },
      });

      setMunicipalities(res.data.data || []);
    } catch (error) {
      console.error("Municipality Error:", error);

      if (error.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
                localStorage.clear();

        navigate("/ulb/login");
      } else {
        Swal.fire("Alert!", "Failed to load municipalities", "error");
      }
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + maxPagesToShow - 1);

    if (end - start < maxPagesToShow - 1) {
        start = Math.max(1, end - maxPagesToShow + 1);
    }

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return pages;
  };

  const fetchSchoolCategoryList = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/schoolCategoriesList`,
        getAuthHeader()
      );

      setCategoryList(res.data?.data.schoolCategoriesList || []);
    } catch (err) {
      console.error(err);

      if (err.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
                localStorage.clear();

        navigate("/ulb/login");
      } else {
        Swal.fire("Alert", "Failed to load school categories", "error");
      }
    }
  };

  /*  FETCH SCHOOL LIST */
  const fetchSchools = async (pageNo = 1, searchValue = filters.searchKey) => {
  setLoading(true);
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/schoolList`,
      {
        searchKey: searchValue,
        page: pageNo,
        per_page: perPage,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const totalRecords = Number(res.data.total_records || 0);
const perPageValue = Number(res.data.per_page || perPage);

setSchools(res.data.data || []);
setPage(res.data.page || pageNo);
setTotalRecords(totalRecords);

// ✅ Calculate total pages manually
setTotalPages(Math.ceil(totalRecords / perPageValue));

  } catch (error) {
    console.error("Fetch Schools Error:", error);
          if (handle401(error)) return;

  } finally {
    setLoading(false);
  }
};


  const fetchSections = async () => {
    try {
        const token = localStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/sectionList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        setSections(res.data.data.sectionList);
      }
    } catch (error) {
      console.error("Section list error", error);
      if (handle401(error)) return;
    }
  };

  const fetchClassList = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.get(`${BASE_URL}/classList`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.data.status) {
      setClassList(res.data.data.class_list);
    }
  } catch (error) {
    console.error("Class list error", error);
    if (handle401(error)) return;
  }
};

const fetchSchoolDetails = async (id) => {
  try {
    setClassStrengths([]);

const token = localStorage.getItem("token");
    const res = await axios.get(`${BASE_URL}/schoolDetails/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data.status) {
      const { details, students_count } = res.data.data;
console.log("students_count:", students_count); // <-- ADD HERE

      if (details) {
        setSchoolCode(details.code || "");
        setSchoolName(details.name || "");
        setSchoolAddress(details.address || "");
        setLowClass(details.low_class || "");
        setHighClass(details.high_class || "");
        setManagement(details.management?.toString() || "");
        setCategory(details.category?.toString() || "");
        setType(details.type?.toString() || "");
        setEstablishmentYear(details.establishment_year || "");

        // populate class strength rows
//         const rows =
//   students_count && students_count.length
//     ? students_count.map(s => ({
//         class_id: s.class_id,
//         section_id: s.section_id,
//         boys: s.boys_count,
//         girls: s.girls_count,
//         others: s.transgender_count,
//       }))
//     : [];

const rows =
  students_count && students_count.length
    ? students_count.map((s, index) => ({
        id: Date.now() + index, // ✅ UNIQUE ID
        class_id: String(s.class_id),
        section_id: String(s.section_id),
        boys: s.boys_count,
        girls: s.girls_count,
        others: s.transgender_count,
      }))
    : [];

setClassStrengths(rows);
    //  setClassStrengths(rows);

      }
    } else {
      Swal.fire("Alert!", res.data.message || "Failed to fetch school details", "error");
    }
  } catch (error) {
    Swal.fire(
      "Alert!",
      error?.response?.data?.message || "Failed to fetch school details",
      "error"
    );
    if (handle401(error)) return;

  }
};





  const fetchSchoolManagementTypeList = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/schoolManagementTypeList`,
        getAuthHeader()
      );

      setManagementList(res.data?.data.schoolManagementTypeList || []);
    } catch (err) {
      console.error(err);

      if (err.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
                localStorage.clear();

        navigate("/ulb/login");
      } else {
        Swal.fire(
          "Alert",
          "Failed to load school management types",
          "error"
        );
      }
    }
  };


  const fetchSchoolTypeList = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/schoolTypesList`,
        getAuthHeader()
      );

      setTypeList(res.data?.data.schoolTypesList || []);
    } catch (err) {
      console.error(err);
      if (handle401(err)) return;

      if (err.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
                localStorage.clear();

        navigate("/ulb/login");
      } else {
        Swal.fire("Alert", "Failed to load school types", "error");
      }
    }
  };

  const fetchSubdivisionList = async (districtId) => {
    districtId = localStorage.getItem("districtId");
    if (!districtId) {
      setSubDivisions([]);
      return;
    }

    try {
      const res = await axios.post(
        `${BASE_URL}/subDivisionList`,
        { district_id: districtId },
        getAuthHeader()
      );

      setSubDivisions(res.data?.data || []);
    } catch (err) {
      console.error("Subdivision load error:", err);
      Swal.fire("Alert", "Failed to load subdivisions", "error");
    }
  };


  const fetchCircleList = async (subDivisionId) => {
    if (!subDivisionId) {
      setcircleList([]);
      return;
    }

    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/circleMasterList`,
        {
          sub_division_id: subDivisionId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setcircleList(res.data?.data || []);
    } catch (err) {
      console.log("Circle load error:", err);
      Swal.fire("Alert", "Failed to load circles", "error");
    }
  };



useEffect(() => {
    fetchSchoolManagementTypeList();
    fetchSchoolTypeList();
    fetchSchoolCategoryList();
    // fetchSubdivisionList();
    fetchClassList();
    fetchSections();
  }, []);


  useEffect(() => {
    const userTypeId = localStorage.getItem("userTypeId");

    fetchSchools(1, filters.searchKey);

    if (userTypeId === "1") {
      fetchMunicipalities();
    }
  }, [perPage]);




const openAddModal = () => {
  setShowModal(true);
  setIsEdit(false);
  setEditId(null);
  setSchoolName("");
  setSchoolCode("");
  setSchoolAddress("");
  setMunicipalityId("");
  setEstablishmentYear("");
  setLowClass("");
  setHighClass("");
  setManagement("");
  setCategory("");
  setType("");
  setClassStrengths([
    {
      class_id: "",
      section_id: "",
      boys: "",
      girls: "",
      others: "",
    },
  ]); // ✅ Reset class strength rows
  fetchClassList("");
  setSubDivisionId("");
  setCircleId("");
};

const openEditModal = async (row) => {
  try {
    setClassStrengths([]); // clear first
    setIsEdit(true);
    setEditId(row.id);

    await fetchSchoolDetails(row.id); // wait for data

    // set other fields
    setSchoolName(row.name);
    setSchoolCode(row.code);
    setSchoolAddress(row.address);
    setMunicipalityId(row.municipality_id);
    setEstablishmentYear(row.establishment_year || "");
    setLowClass(row.low_class || "");
    setHighClass(row.high_class || "");
    setManagement(row.management || "");
    setCategory(row.category || "");
    setType(row.type || "");

    // open modal AFTER fetch
    setShowModal(true);
  } catch (e) {
    console.error(e);
  }
};

const closeModal = () => {
  setShowModal(false);
  setIsEdit(false);
  setEditId(null);

  // reset all modal states
  setSchoolCode("");
  setSchoolName("");
  setSchoolAddress("");
  setLowClass("");
  setHighClass("");
  setManagement("");
  setCategory("");
  setType("");

  setClassStrengths([]); // critical
};






const handleSave = async () => {
  try {
    setSaving(true);
    const token = localStorage.getItem("token");

    if (
      !schoolCode ||
      !lowClass ||
      !highClass ||
      !management ||
      !category ||
      !type ||
      !schoolName ||
      !schoolAddress
    ) {
      setSaving(false);
      return Swal.fire(
        "Warning!",
        "All required fields must be filled",
        "warning"
      );
    }

    const validRows = classStrengths.filter(
      row => row.class_id && row.section_id
    );

    if (!validRows.length) {
      setSaving(false);
      return Swal.fire(
        "Warning!",
        "Please add at least one class and section strength",
        "warning"
      );
    }

    const payload = {
      code: schoolCode,
      establishment_year: establishmentYear || "",
      low_class: lowClass,
      high_class: highClass,
      management: String(management),
      category: String(category),
      type: String(type),
      name: schoolName,
      address: schoolAddress,
      sub_division_id: "",
      circle_id: "",
      class_ids: validRows.map(r => Number(r.class_id)),
      section_ids: validRows.map(r => Number(r.section_id)),
      boys_student_count: validRows.map(r => Number(r.boys || 0)),
      girls_student_count: validRows.map(r => Number(r.girls || 0)),
      others_student_count: validRows.map(r => Number(r.others || 0)),
    };

    if (isEdit) payload.id = editId;

    const res = await axios.post(
      `${BASE_URL}/schoolAddEdit`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    Swal.fire(
      "Success!",
      res.data?.message ||
        (isEdit
          ? "School updated successfully"
          : "School added successfully"),
      "success"
    );

    fetchSchools(page, filters.searchKey);
    setShowModal(false);
  } catch (error) {
    Swal.fire(
      "Error!",
      error?.response?.data?.message || "Operation failed",
      "error"
    );
    if (handle401(error)) return;
  } finally {
    setSaving(false);
  }
};









  /* ✅ DELETE SCHOOL */
  const deleteSchool = async (id) => {
    if (!window.confirm("Are you sure want to delete?")) return;

    try {
  const token = localStorage.getItem("token");

      await axios.delete(`${BASE_URL}/schools/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire("Deleted!", "School deleted successfully", "success");
      fetchSchools(1);
    } catch (error) {
      console.error("Delete Error:", error);

      if (error.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
                localStorage.clear();

        navigate("/ulb/login");
      } else {
        Swal.fire("Alert!", "Failed to delete school", "error");
      }
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔍 FILTER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Schools
          </h5>
        </div>
        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter school..."
                  value={filters.searchKey}
                  onChange={(e) =>
                    setFilters({ ...filters, searchKey: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                />
              </Form.Group>
            </Col>

             <Col md={3}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

      <Form.Select
        style={{
          borderRadius: "10px",
          border: "2px solid #1565C1",
        }}
        value={perPage}
        onChange={(e) => {
          const value = Number(e.target.value);
          setPerPage(value);
          setPage(1);
        }}
      >
        <option value={10}>10 Per Page</option>
        <option value={25}>25 Per Page</option>
        <option value={50}>50 Per Page</option>
        <option value={100}>100 Per Page</option>
      </Form.Select>
    </Form.Group>
  </Col>


            <Col md={4} className="d-flex gap-3 mt-3">
              {/* SEARCH */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                onClick={() => fetchSchools(1,filters.searchKey)}

              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              {/* RESET */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#E53935",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                onClick={() => {
                  setFilters({ searchKey: "" });
                                    setPerPage(10)

                  fetchSchools(1, "");
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Button
        className="mb-3 px-4 text-white fw-semibold"
        onClick={openAddModal}
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          border: "none",
          borderRadius: "10px",
          padding: "10px 22px",
          boxShadow: "0 6px 15px rgba(46,125,50,0.4)",
          transition: "0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #1B5E20, #2E7D32)";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 10px 22px rgba(46,125,50,0.55)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #2E7D32, #66BB6A)";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 6px 15px rgba(46,125,50,0.4)";
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Add School
      </Button>

      {/* <Button
  className="mb-3 px-4 text-white fw-semibold ms-2"
  style={{
    background: "linear-gradient(135deg, #1565C0, #42A5F5)",
    border: "none",
    borderRadius: "10px",
    padding: "10px 22px",
    boxShadow: "0 6px 15px rgba(21,101,192,0.4)",
  }}
  onClick={() => setShowImportModal(true)}
>
  <i className="fa-solid fa-file-import me-2"></i> Import CSV
</Button> */}


       {/* <Button
        className="mb-3 px-4 text-white fw-semibold ms-2"
      //   onClick={openImportModal} // or your import handler
        style={{
          background: "linear-gradient(135deg, #1565C0, #42A5F5)",
          border: "none",
          borderRadius: "10px",
          padding: "10px 22px",
          boxShadow: "0 6px 15px rgba(21,101,192,0.4)",
          transition: "0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #0D47A1, #1565C0)";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 10px 22px rgba(21,101,192,0.55)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #1565C0, #42A5F5)";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            "0 6px 15px rgba(21,101,192,0.4)";
        }}
      >
        <i className="fa-solid fa-file-import me-2"></i> Import CSV
      </Button> */}


      {loading && (
  <div className="loader-wrapper">
    <div className="blue-spinner"></div>

    <div className="loading-line">
      <div className="loading-progress"></div>
    </div>

    <p className="loading-text">Loading, please wait...</p>
  </div>
)}

      {/* 📄 TABLE */}
      {!loading && (

      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}
      >
        <Table bordered hover responsive striped>
          <thead className="text-white">
            <tr>
              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                SL
              </th>
              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                School Name
              </th>

              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                Category
              </th>
              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                Management
              </th>
              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                Type
              </th>

              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                Code
              </th>
              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                Address
              </th>
              <th
                style={{
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }}
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {schools.length > 0 ? (
              schools.map((row, i) => (
                <tr key={row.id}>
 <td className="text-center">
          {(page - 1) * perPage + i + 1}
        </td>                  <td className="text-center">{row.name}</td>
                          <td className="text-center">{row.category_name}</td>

                  <td className="text-center">{row.management_name}</td>
                  <td className="text-center">{row.type_name}</td>
                  <td className="text-center">{row.code}</td>
                  <td className="text-center">{row.address}</td>
                  <td className="text-center">
                    <Button
                      size="sm"
                      className="me-2"
                      style={{
                        background: "#1565C1",
                        border: "none",
                        padding: "6px 10px",
                        boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#0D47A1")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "#1565C1")
                      }
                      onClick={() => openEditModal(row)}
                    >
                      <i className="fa-solid fa-pen text-white"></i>
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
  <nav>
    <ul className="pagination shadow-sm">

      {/* First */}
      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchSchools(1)}>
          «
        </button>
      </li>

      {/* Prev */}
      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchSchools(page - 1)}>
          ‹
        </button>
      </li>

      {/* Page Numbers */}
      {getPageNumbers().map((p) => (
        <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
          <button className="page-link" onClick={() => fetchSchools(p)}>
            {p}
          </button>
        </li>
      ))}

      {/* Next */}
      <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchSchools(page + 1)}>
          ›
        </button>
      </li>

      {/* Last */}
      <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchSchools(totalPages)}>
          »
        </button>
      </li>

    </ul>
  </nav>
</div>
        )}
      </Card>
      )}

      {/* MODAL */}
      <Modal key={editId || "new"} show={showModal} onHide={closeModal}
 centered size="lg"  backdrop="static"
  keyboard={false} >
  <Modal.Header
    closeButton
    style={{ background: "#3399ff", color: "white" }}
  >
    <Modal.Title>{isEdit ? "Edit School" : "Add School"}</Modal.Title>
  </Modal.Header>

  <Modal.Body>

    <Row>
      <Col md={6}>
        <Form.Group className="mb-2">
          <Form.Label>
            School Code <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            value={schoolCode}
            onChange={(e) => setSchoolCode(e.target.value)}
            placeholder="Enter School Code"
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-2">
          <Form.Label>
            School Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            value={schoolName}
            onChange={(e) => setSchoolName(e.target.value)}
            placeholder="Enter School Name"
          />
        </Form.Group>
      </Col>


    </Row>

    <Row>
      <Col md={6}>
  <Form.Group className="mb-2">
    <Form.Label>
      Low Class <span className="text-danger">*</span>
    </Form.Label>

    <Form.Select
      value={lowClass}
      onChange={(e) => setLowClass(e.target.value)}
    >
      <option value="">Select Low Class</option>
      {classList.map(item => (
        <option key={item.id} value={item.name}>
          {item.name.trim()}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>


      <Col md={6}>
  <Form.Group className="mb-2">
    <Form.Label>
      High Class <span className="text-danger">*</span>
    </Form.Label>

    <Form.Select
      value={highClass}
      onChange={(e) => setHighClass(e.target.value)}
    >
      <option value="">Select High Class</option>
      {classList.map(item => (
        <option key={item.id} value={item.name}>
          {item.name.trim()}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

    </Row>

    <Row>
      <Col md={6}>
  <Form.Group className="mb-2">
    <Form.Label>Management <span className="text-danger">*</span></Form.Label>
    <Form.Select
      value={management}
      onChange={(e) => setManagement(e.target.value)}
    >
      <option value="">Select Management</option>
      {managementList.map((m) => (
        <option key={m.id} value={m.id}>
          {m.name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

<Col md={6}>
  <Form.Group className="mb-2">
    <Form.Label>Category <span className="text-danger">*</span></Form.Label>
    <Form.Select
      value={category}
      onChange={(e) => setCategory(e.target.value)}
    >
      <option value="">Select Category</option>
      {categoryList.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

    </Row>

    <Row>
      <Col md={6}>
  <Form.Group className="mb-2">
    <Form.Label>Type <span className="text-danger">*</span></Form.Label>
    <Form.Select
      value={type}
      onChange={(e) => setType(e.target.value)}
    >
      <option value="">Select Type</option>
      {typeList.map((t) => (
        <option key={t.id} value={t.id}>
          {t.name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

 <Col md={6}>
        <Form.Group className="mb-2">
          <Form.Label>Establishment Year <span className="text-muted">(Optional)</span></Form.Label>
          <Form.Control
            type="number"
            value={establishmentYear}
            onChange={(e) => setEstablishmentYear(e.target.value)}
            placeholder="Enter Year"
          />
        </Form.Group>
      </Col>



    </Row>

    <hr />
    <h6 className="fw-bold text-primary">Class Wise Student Strength</h6>

    {classStrengths.map((row, index) => (
      <Card key={row.id} className="mb-3 shadow-sm">
        <Card.Body style={{ position: "relative" }}>
          {index > 0 && !isEdit && classStrengths.length > 1 && (
  <Button
    variant="danger"
    size="sm"
    onClick={() => removeClassRow(index)}
    style={{
      position: "absolute",
      top: "8px",
      right: "8px",
      borderRadius: "10%",
      width: "30px",
      height: "30px",
      padding: "0",
      fontSize: "16px",
      lineHeight: "1",
    }}
  >
    ×
  </Button>
)}

          <Row>
            <Col md={6} className="mb-2">
              <Form.Label>Class</Form.Label>
              <Form.Select
                value={row.class_id}
                onChange={(e) =>
                  handleClassChange(index, "class_id", e.target.value)
                }
              >
                <option value="">Select Class</option>
                {classList.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Label>Section</Form.Label>
              <Form.Select
  value={row.section_id}
  onChange={(e) =>
    handleClassChange(index, "section_id", e.target.value)
  }
>
  <option value="">Select Section</option>
  {sections.map((sec) => (
    <option key={sec.id} value={sec.id}>
      {sec.section_name}
    </option>
  ))}
</Form.Select>

            </Col>

            <Col md={4}>
              <Form.Label>Boys</Form.Label>
              <Form.Control
                type="number"
                value={row.boys}
                onChange={(e) =>
                  handleClassChange(index, "boys", e.target.value)
                }
                placeholder="Enter Student Number"
              />
            </Col>

            <Col md={4}>
              <Form.Label>Girls</Form.Label>
              <Form.Control
                type="number"
                value={row.girls}
                onChange={(e) =>
                  handleClassChange(index, "girls", e.target.value)
                }
                placeholder="Enter Student Number"
              />
            </Col>

            <Col md={4}>
              <Form.Label>Others</Form.Label>
              <Form.Control
  type="number"
  value={row.others}
  onChange={(e) =>
    handleClassChange(index, "others", e.target.value)
  }
/>


            </Col>
          </Row>
        </Card.Body>
      </Card>
    ))}

    <div className="d-flex justify-content-end mt-3">
      <Button
        size="sm"
        onClick={addClassRow}
        style={{
          background: "#1565C1",
          border: "none",
          borderRadius: "8px",
          padding: "6px 14px",
        }}
      >
        + Add More
      </Button>
    </div>

    <Row>
      <Col md={12}>
        <Form.Group className="mt-2">
          <Form.Label>
            Address <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            value={schoolAddress}
            onChange={(e) => setSchoolAddress(e.target.value)}
            rows={3}
            placeholder="Enter Address"
          />
        </Form.Group>
      </Col>
    </Row>
  </Modal.Body>

  <Modal.Footer>
<Button onClick={() => {
  setShowModal(false);
  setIsEdit(false);
  setEditId(null);
  setClassStrengths([]);
}}>
  Cancel
</Button>
    <Button
  variant="success"
  onClick={handleSave}
  disabled={saving}
>
  {saving ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
      ></span>
      {isEdit ? "Updating..." : "Saving..."}
    </>
  ) : (
    isEdit ? "Update" : "Submit"
  )}
</Button>
  </Modal.Footer>
</Modal>


      <Modal
  show={showImportModal}
  onHide={() => setShowImportModal(false)}
  size="lg"
  centered backdrop="static"
  keyboard={false}
>
  <Modal.Header closeButton style={{ background: "#1565C1", color: "white" }}>
    <Modal.Title>Import Schools from CSV</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form.Group className="mb-3">
      <Form.Label>Upload CSV File</Form.Label>
      <Form.Control
        type="file"
        accept=".csv"
        onChange={(e) => setCsvFile(e.target.files[0])}
      />
    </Form.Group>

    {csvFile && (
      <Button variant="info" >
        Preview
      </Button>
    )}

    {previewData.length > 0 && (
      <>
        <hr />
        <h6>Preview</h6>

        <Table bordered size="sm">
          <thead>
            <tr>
              <th>School Name</th>
              <th>Code</th>
              <th>Address</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {previewData.map((row, i) => (
              <tr key={i}>
                <td>{row.name}</td>
                <td>{row.code}</td>
                <td>{row.address}</td>
                <td>
                  {row.error ? (
                    <span className="text-danger">{row.error}</span>
                  ) : (
                    <span className="text-success">OK</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowImportModal(false)}>
      Cancel
    </Button>

    <Button
      variant="success"
      disabled={csvErrors.length > 0 || previewData.length === 0}
    //   onClick={handleImportCSV}
    >
      Import
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default School;
